export default {
  PAGE_READY_TIMEOUT: 300,
  LOGO_CHECK_INTERVAL: 500,
  GOOGLE_MAPS_API_KEY: `AIzaSyCxIh4GqWTL8FZe0xS4FGugpsHQ98JtM4I`,
};
